<template>
  <div class="flex relative justify-center items-center">
    <svg-icon
      class="absolute left-0 cursor-pointer"
      name="arrow-back"
      @click="emit('goBack')"
    />
    <span class="secondary-modal-header">
      {{ plainText }}
    </span>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import SvgIcon from '@/shared/ui/SvgIcon/SvgIcon.vue'

defineProps({
  plainText: {
    type: [String, Object],
    default: '',
  },
})

const emit = defineEmits(['goBack'])
</script>

<style scoped lang="scss">
.secondary-modal-header {
  color: var(--text-1);
  font-size: 20px;
  font-weight: 500;
}
</style>
